import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  public loginDetail:any =[];


  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login');
    this.sideIcon(true);
  }

  close(){
    $('#CONFIRMPopup').modal('toggle');
  }

  redirect(){
    this.router.navigate(['/dashboard']);
  }

  over(status = 1) {
    if (localStorage.getItem('sidebar_selection')) {
      const sidebar_selection = localStorage.getItem('sidebar_selection');
      if (sidebar_selection && status == 1) {
        $('.main-site-wrap').addClass('sidebar-hovered');
      } else {
        $('.main-site-wrap').removeClass('sidebar-hovered');
      }
    }
  }

  sideIcon(firstLogin = false) {
    if (localStorage.getItem('sidebar_selection')) {
      const sidebar_selection = localStorage.getItem('sidebar_selection');
      if (firstLogin) {
        if (sidebar_selection == '1') {
          $('.main-site-wrap').addClass('toggled');
        }
      } else {
        if (sidebar_selection == '1') {
          $('.main-site-wrap').removeClass('toggled').removeClass('sidebar-hovered');
          localStorage.setItem('sidebar_selection', '0');
        } else {
          $('.main-site-wrap').addClass('toggled');
          localStorage.setItem('sidebar_selection', '1');
        }  
      }
      
    } else {
      $('.main-site-wrap').addClass('toggled');
      localStorage.setItem('sidebar_selection', '1');
    }
  }
}
